import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MegamenuComponent } from '../megamenu/megamenu.component';
import { FooterComponent } from '../footer/footer.component';
import { CompanyConfigService, CompanyConfig } from '../../services/company-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-service-areas',
  templateUrl: './service-areas.component.html',
  styleUrl: './service-areas.component.css',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MegamenuComponent,
    FooterComponent
  ]
})
export class ServiceAreasComponent {
  config: CompanyConfig;
  
  // Group service areas by region for better organization
  serviceRegions = [
    {
      name: 'Weber County',
      areas: [] as string[],
      description: 'Comprehensive pest control services throughout Weber County'
    },
    {
      name: 'Davis County', 
      areas: [] as string[],
      description: 'Professional pest management for Davis County communities'
    },
    {
      name: 'Box Elder County',
      areas: [] as string[],
      description: 'Reliable pest control solutions in Box Elder County'
    }
  ];

  constructor(
    private companyConfig: CompanyConfigService,
    private router: Router
  ) {
    this.config = this.companyConfig.getConfig();
    this.organizeServiceAreas();
  }

  private organizeServiceAreas() {
    // Weber County cities
    const weberCountyCities = [
      'South Ogden', 'North Ogden', 'Riverdale', 'Roy', 'West Haven', 
      'Marriott-Slaterville', 'Harrisville', 'Pleasant View', 'Hooper', 
      'Plain City', 'Uintah', 'Washington Terrace', 'Huntsville'
    ];

    // Davis County cities
    const davisCountyCities = [
      'Layton', 'Clearfield', 'Kaysville', 'Clinton', 'Sunset', 
      'Syracuse', 'West Point', 'Fruit Heights'
    ];

    // Box Elder County cities
    const boxElderCountyCities = [
      'Brigham City', 'Perry', 'Willard'
    ];

    // Filter and assign cities to regions
    this.serviceRegions[0].areas = this.config.serviceAreas.filter(area => 
      weberCountyCities.includes(area)
    );
    
    this.serviceRegions[1].areas = this.config.serviceAreas.filter(area => 
      davisCountyCities.includes(area)
    );
    
    this.serviceRegions[2].areas = this.config.serviceAreas.filter(area => 
      boxElderCountyCities.includes(area)
    );
  }

  callPhone() {
    this.companyConfig.callPhone();
  }

  navigateToContact() {
    this.router.navigate(['/contact']);
  }

  openDirections() {
    this.companyConfig.openDirections();
  }
}